module.exports = __webpack_public_path__ + "img/IT0004492253257.f070ff82.png";